import React, { useEffect, useState } from "react";
import { C, FONT } from "./data";

const svg = (props, viewBox = 24) => ({ viewBox: `0 0 ${viewBox} ${viewBox}`, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props });

export const Ic = {
  sparkles: (props) => <svg {...svg(props)}><path d="M12 3l1.8 4.9L18.7 9.7 13.8 11.5 12 16.4 10.2 11.5 5.3 9.7 10.2 7.9 12 3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/><path d="M19 14l.7 1.9 1.9.7-1.9.7L19 19.2 18.3 17.3 16.4 16.6l1.9-.7L19 14Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/></svg>,
  mail: (props) => <svg {...svg(props)}><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2"/><path d="m4 7 8 6 8-6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/></svg>,
  panel: (props) => <svg {...svg(props)}><rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M14 4v16" stroke="currentColor" strokeWidth="2"/></svg>,
  x: (props) => <svg {...svg(props)}><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>,
  chevronRight: (props) => <svg {...svg(props)}><path d="m9 6 6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
};

export function KpiCard({ label, value, sub, accent }) {
  return (
    <div style={{ flex: "1 1 220px", minWidth: 200, background: C.white, border: `1px solid ${C.border}`, borderRadius: 12, display: "flex", overflow: "hidden" }}>
      <div style={{ width: 4, flex: "0 0 4px", background: accent }} />
      <div style={{ padding: 12, display: "flex", flexDirection: "column", gap: 4 }}>
        <span style={{ color: C.gray, fontWeight: 600, fontSize: 11, textTransform: "uppercase" }}>{label}</span>
        <span style={{ color: C.ink2, fontWeight: 700, fontSize: 24, lineHeight: 1 }}>{value}</span>
        <span style={{ color: C.gray, fontSize: 12 }}>{sub}</span>
      </div>
    </div>
  );
}

export function KpiRow({ items }) {
  return <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>{items.map((item, index) => <KpiCard key={index} {...item} />)}</div>;
}

export function Eyebrow({ children, font = FONT }) {
  return <span style={{ color: C.gray, fontWeight: 700, fontSize: 11, letterSpacing: 0.3, textTransform: "uppercase", fontFamily: font }}>{children}</span>;
}

export function GradButton({ children, onClick, disabled = false }) {
  return (
    <button onClick={onClick} disabled={disabled}
      style={{ display: "inline-flex", alignItems: "center", gap: 8, height: 28, padding: "0 20px", borderRadius: 99, border: "none",
        cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.6 : 1,
        background: `linear-gradient(90deg,${C.triage1},${C.triage2})`, color: "#fff", fontFamily: FONT, fontSize: 13, fontWeight: 600 }}>
      {children}
    </button>
  );
}

export function ClassBadge({ kind, text }) {
  if (kind === "amber") {
    return <span style={{ display: "inline-flex", alignItems: "center", height: 20, padding: "0 8px", borderRadius: 6, background: C.amberBg, border: `1px solid ${C.amberBorder}`, color: C.amberText, fontWeight: 700, fontSize: 10, whiteSpace: "nowrap" }}>{text}</span>;
  }
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4, height: 20, padding: "0 8px", borderRadius: 6,
      background: `linear-gradient(90deg,${C.badgePurpleBg1},${C.badgePurpleBg2})`, color: C.purple, fontWeight: 700, fontSize: 10, whiteSpace: "nowrap",
      border: "1px solid transparent", backgroundImage: `linear-gradient(90deg,${C.badgePurpleBg1},${C.badgePurpleBg2}), linear-gradient(90deg,${C.gradBorder1},${C.gradBorder2})`, backgroundOrigin: "border-box", backgroundClip: "padding-box, border-box" }}>
      <Ic.sparkles width={10} height={10} style={{ color: C.gradBorder2, flex: "0 0 10px" }} />{text}
    </span>
  );
}

export function colHead(width) {
  return { flex: width ? `0 0 ${width}px` : undefined, width: width || undefined, color: C.gray, fontWeight: 700, fontSize: 11, textTransform: "uppercase" };
}
export function cell(width) { return { flex: `0 0 ${width}px`, width, minWidth: 0 }; }

export function BarChart({ title, rows, labelW, gradFrom, gradTo, chipBg, chipColor, maxVal, suffix = "" }) {
  const max = maxVal || Math.max(...rows.map((row) => row.v));
  return (
    <div style={{ flex: 1, minWidth: 280, display: "flex", flexDirection: "column", gap: 12 }}>
      <span style={{ color: C.ink2, fontWeight: 600, fontSize: 12 }}>{title}</span>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {rows.map((row, index) => {
          const pct = Math.max(6, Math.round((row.v / max) * 100));
          return (
            <div key={index} style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ flex: `0 0 ${labelW}px`, width: labelW, color: C.muted, fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{row.m || row.label}</span>
              <span style={{ flex: "0 0 auto", height: 16, display: "inline-flex", alignItems: "center", padding: "0 6px", borderRadius: 4, background: chipBg || gradFrom, color: chipColor || "#fff", fontWeight: 600, fontSize: 10 }}>{row.v}{suffix}</span>
              <div style={{ flex: 1, height: 12, borderRadius: 4, background: "transparent", position: "relative" }}>
                <div style={{ width: `${pct}%`, height: 12, borderRadius: 4, background: `linear-gradient(90deg,${gradFrom},${gradTo})` }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function usePrefersReducedMotion() {
  const [reduce, setReduce] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const updatePreference = () => setReduce(mediaQuery.matches);
    updatePreference();
    if (mediaQuery.addEventListener) mediaQuery.addEventListener("change", updatePreference);
    else if (mediaQuery.addListener) mediaQuery.addListener(updatePreference);
    return () => {
      if (mediaQuery.removeEventListener) mediaQuery.removeEventListener("change", updatePreference);
      else if (mediaQuery.removeListener) mediaQuery.removeListener(updatePreference);
    };
  }, []);
  return reduce;
}

export function GlobalStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Albert+Sans:wght@400;600;700&display=swap');
      *, *::before, *::after { box-sizing: border-box; }
      .np-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
      .np-scroll::-webkit-scrollbar-thumb { background: rgba(120,120,140,0.30); border-radius: 8px; }
      .np-scroll::-webkit-scrollbar-track { background: transparent; }
      .np-row:hover { background: #F5F3FF !important; }
      button:focus-visible, [role="button"]:focus-visible, input:focus-visible, [role="tab"]:focus-visible {
        outline: 2px solid ${C.purple}; outline-offset: 2px; border-radius: 8px;
      }
      @keyframes np-spin { to { transform: rotate(360deg); } }
      .np-spin { animation: np-spin 0.9s linear infinite; transform-origin: 50% 50%; }
      @keyframes np-fade { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: none; } }
      .np-fade { animation: np-fade 0.35s ease both; }
      @keyframes np-toast-in { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }
      .np-toast { animation: np-toast-in 0.3s cubic-bezier(.2,.8,.2,1) both; }
      @media (max-width: 1024px) {
        .psq-case-grid { grid-template-columns: 1fr !important; }
        .psq-2col { grid-template-columns: 1fr !important; }
        .psq-sys-cards { grid-template-columns: repeat(2, 1fr) !important; }
      }
      @media (prefers-reduced-motion: reduce) {
        .np-spin, .np-fade, .np-toast { animation: none !important; }
      }
    `}</style>
  );
}
